// 汎用性ボタン
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  btn_class?: string;
  handleClick: React.MouseEventHandler;
}

const TransitionButton: React.FC<Props> = ({ label, btn_class, handleClick }) => {
  return (
    <Row className="row-left-button">
      <Col className={'text-left p-0'} xl={6} lg={6} md={6} sm={6} xs={12}>
        <a className={`btn btn-xl btn-main-color ${btn_class}`} onClick={handleClick}>
          {label}
        </a>
      </Col>
      <Col xl={6} lg={6} md={6} sm={6} xs={12} />
    </Row>
  );
};

export default TransitionButton;
